import {Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FileHelpers} from '../../core/utilities/file.helpers';
import * as _ from 'lodash';
import {fromEvent, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { DroppableDirective } from '../../core/visual/droppable/droppable.directive';

@Component({
    selector: 'app-template-upload-input',
    template: `
    <div class="row">
      <div class="upload-wrapper col-lg-12" *ngIf="!file">
        <input #fileInput [name]="name" id="{{_id}}-input" class="file-input" type="file" [accept]="mimeTypes"
               (change)="fileChangeEvent($event)"
               placeholder="Choose a file..."/>
        <label class="file-input-label" for="{{_id}}-input" title="Choose a file...">
          <i class="material-icons">attach_file</i>
          Select, drag file here
        </label>
        <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
          <div>Drop File Here</div>
        </div>
      </div>
      <div class="preview-attachment col-lg-12" *ngIf="previewFileName">
        <div>
          {{previewFileName}}
          <span (click)="removeAttachment()" class="remove-attachment" title="Remove attachment">
              <i class="material-icons">close</i>
            </span>
        </div>
        <div #previewContainer class="inner-container">
          <!--<div style="display: inline-block; width: 100%; padding: 5px; background-color: transparent; height: 60px;">
            <audio #audioPreview controls></audio>
          </div>-->
        </div>
      </div>
    </div>`,
    styleUrls: ['./template-upload-input.component.scss'],
    standalone: true,
    imports: [NgIf, DroppableDirective],
})
export class TemplateUploadInputComponent implements OnInit, OnChanges, OnDestroy {

  @Input() id: string;
  @Input() name: string;
  @Input() mimeTypes: string;
  @Input() allowImages: boolean;

  _id: string;

  file: File;
  previewUrl: string;
  previewFileName: string;

  containerHeight = 100;
  resizeSubscription: Subscription;

  @ViewChild('fileInput', {static: true}) fileInput: any;
  @ViewChild('audioPreview') audioPreview: any;
  @ViewChild('previewContainer') previewContainer: ElementRef;

  @Output() valueChanged = new EventEmitter<File>();
  @Output() validationError = new EventEmitter<string>();

  constructor() {
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(300))
      .subscribe((event) => {
        console.log('On resize fax upload');
        this.updateSize();
      });
  }

  setId(): void {
    if (this.id) {
      this._id = this.id;
    } else if (this.name) {
      this._id = this._id = _.uniqueId(`${this.name}_`);
    } else {
      this._id = _.uniqueId('id_');
    }
  }

  fileChangeEvent(fileInput: any) {
    const files = fileInput.target.files;
    if (files.length > 0) {
      const file: File = files[0];
      this.validateAndProceedFile(file);
    }
  }

  dropFile(event: DragEvent) {
    console.log('drop event');

    const files = event.dataTransfer.files;

    if (files.length > 0) {
      const file: File = files[0];
      this.validateAndProceedFile(file);
    }
  }

  validateAndProceedFile(file: File) {
    if (FileHelpers.isSupportedFile(file, 'sms')) {
      // if (FileHelpers.isSupportedFaxFileSize(file)) {
      this.file = file;
      this.valueChanged.emit(file);
      this.previewFile(file);
      /*} else {
        this.validationError.emit('File size must be less then 10MB');
      }*/
    } else {
      this.validationError.emit('File type is not supported');
    }
  }

  removeAttachment() {
    this.file = undefined;
    this.previewUrl = null;
    this.previewFileName = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }

    this.valueChanged.emit(this.file);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  ngOnInit(): void {
    this.setId();
    this.updateSize();
  }

  updateSize() {
    if (this.previewContainer) {
      this.containerHeight = this.previewContainer.nativeElement.clientWidth * 1.4142 + 10;
    }
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription?.unsubscribe();
    }
  }

  private previewFile(file: File) {
    this.previewFileName = file.name;
    this.previewUrl = null;

    if (file.type.indexOf('audio') > -1) {
      console.log('preview audio');
      this.previewUrl = URL.createObjectURL(file);
      setTimeout(() => {
        this.audioPreview.nativeElement.src = this.previewUrl;
      }, 10);
    }
  }
}
